import React, { Component } from "react";
import { connect } from "react-redux";
import TireTriage from "../../components/tire-triage";
import LockoutTriage from "../../components/lockout-triage";
import JumpStartTriage from "../../components/jumpStart-triage";
import TowTransition from "../../components/tow-transition";
import {
  generatePath,
  generatePathWithSearchParams
} from "./../../utilities/RedirectUtils";
import { datadogRum } from "@datadog/browser-rum";
import {
  updateServiceInfo,
  requestPartnerDetails,
  updateServiceTypeOptions,
  updateCurrentLocation,
  updateTowReason,
  refreshReducersToInitial,
  clearServiceTypeOptions
} from "../../action";
import { recoverFromInvalidOrExpiredSession, sendJacadaRequest } from "../../api";
import CONSTANTS, {
  BATTERY,
  FERRARI,
  FUEL_DELIVERY,
  JUMP_START,
  LOCKOUT,
  SERVICE_CHANGE_ORIGIN,
  TIRE_CHANGE,
  TOW, TRIAGE_TYPE
} from "../../app-consts/appConstants";
import FuelTriage from "../../components/fuel-triage";
import TowTriage from "../../components/tow-triage";
import clearCache from "../../utils/clearCache";
import { isABGPartner } from "../../utils";
import { getOmniStreamlinedFlag } from "../../features/FeatureFlags";
import { callCustomerServicePhone } from "../../utilities/PhoneUtils";
import { TowNotNeeded } from "../../components/tow-not-needed";
import { TowToLockoutTriage } from "../../components/TowToLockoutTriage";

class Triage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transitionToTowService: false,
      transitionToTowNotNeeded: false,
      isTrunk: "Lockout",
    };
  }
  get isFerrari() {
    return this.props.partnerDetails.partnerDetails?.oemVehicleMakesList?.includes(FERRARI);
  }

  componentDidMount() {
    document.title = "Triage | Roadside Assistance";
    const serviceName = localStorage.getItem(TRIAGE_TYPE);
    if (!serviceName) {
      datadogRum.addAction("triage_type not available, User has been redirected to lookup");
      recoverFromInvalidOrExpiredSession(this.props.history, () => {
        this.props.refreshReducersToInitial();
      });
    }
    this.initialization();

    if (this.isFerrari) {
      if (serviceName === JUMP_START) {
        this.updateSoftServiceDetails(true, JUMP_START, { towReason: BATTERY });
      } else if (serviceName === TIRE_CHANGE) {
        this.updateSoftServiceDetails(true, TIRE_CHANGE, { towReason: TIRE_CHANGE });
      }
    }
  }

  initialization = () => {
    const { submitRequest } = this.props;
    if (submitRequest?.success) {
      const {sessionId, callId, requestId, usageId} = submitRequest.response;
      if (!this.props.omniStreamlined && usageId && sessionId && callId && requestId) {
        this.props.history.push(
          generatePath(`tracker/${sessionId}/${callId}/${requestId}/${usageId}`)
        );
      } else if (!!this.props.omniStreamlined && callId && usageId && this.props.displayCode) {
        this.props.history.push(
          generatePathWithSearchParams(`/wd/l/${this.props.displayCode}/${callId}/${usageId}`)
        );
      } else {
        clearCache(() => this.props.refreshReducersToInitial());
        datadogRum.addAction("Recovered from tracker redirection from Triage page");
        return;
      }
    }
  };

  getServiceDetail = (type) => {
    return this.props.serviceDetails.serviceDetails.find(
      (o) => o.serviceText === type
    );
  };

  towType = (isTrunk) => {
    if (isTrunk) this.setState({ isTrunk: "Lockout-Trunk" });
  };

  updateSoftServiceDetails = (isToTow, type, options) => {
    const origin = localStorage.getItem(SERVICE_CHANGE_ORIGIN);
    if (isABGPartner(this.props.displayCode) && !isToTow && origin === TOW) {
      if (type === TIRE_CHANGE) {
        this.props.updateServiceTypeOptions({
        tire: {
          vehicleType: "fourWheeler",
          gotSpare: options.gotSpare,
          replacementTire: options.selectedTire,
          visiblyDamaged: options.visiblyDamaged,
        },
      });

      localStorage.setItem("serviceText", type);
      this.props.updateServiceInfo(this.getServiceDetail(type));

      this.setState({ transitionToTowNotNeeded: true });
      return;
      }
      if (type === LOCKOUT) {
        this.props.updateServiceTypeOptions({
          lockoutType: "KeysInVehicle",
        });

      localStorage.setItem("serviceText", type);
      this.props.updateServiceInfo(this.getServiceDetail(type));

      this.setState({ transitionToTowNotNeeded: true });
      return;
      }
    }
    if (!isToTow) {
      localStorage.setItem("serviceText", type);
      if (type === "Lockout") {
        this.props.updateServiceTypeOptions({
          lockoutType: "KeysInVehicle",
        });
      }
      if (type === "Tire Change") {
        this.props.updateServiceTypeOptions({
          tire: {
            vehicleType: "fourWheeler",
            gotSpare: options.gotSpare,
            replacementTire: options.selectedTire,
            visiblyDamaged: options.visiblyDamaged,
          },
        });
      }
      if (type === "Jump Start") {
        this.props.updateServiceTypeOptions({
          battery: {
            vehicleStoppedWhileDriving: false,
          },
        });
      }
      if (type === FUEL_DELIVERY) {
        this.props.updateServiceTypeOptions({ gas: options.fuelType });
      }
      this.props.updateServiceInfo(this.getServiceDetail(type));
      this.navigateScheduleService();
    } else {
      if(isABGPartner(this.props.displayCode) && origin === TOW) {
        if (this.props.commonBenefits.experience?.towTriageEnabled) {
          this.props.updateTowReason(options?.towReason);
        }
        this.props.updateServiceInfo(this.getServiceDetail(TOW));
        this.navigateScheduleService();
        return;
      } else {
        if (this.props.commonBenefits.experience?.towTriageEnabled) {
          this.props.updateTowReason(options?.towReason);
        }
        this.setState({
          transitionToTowService: true,
        });
        this.props.clearServiceTypeOptions();
      }
    }
  };

  handleClickTowTransition = () => {
    this.props.updateServiceInfo(this.getServiceDetail("Tow"));
    let jacadaRequestData = {
      externalSystemId:
        localStorage.getItem("conversationId") || "not available",
      events: [
        {
          name: "svc_id",
          value: 45,
        },
        {
          name: "event_id",
          value: 52,
        },
      ],
    };
    sendJacadaRequest(jacadaRequestData);
    localStorage.setItem("serviceText", "Tow");
    this.navigateScheduleService();
  };

  navigateScheduleService = () => {
    const {
      partnerDetails: {
        partnerDetails: { experience },
      },
    } = this.props;
    if (experience?.schedulingEnabled) {
      this.props.history.push(generatePath("ScheduleService"));
    } else {
      this.props.updateCurrentLocation({ setFromLocationServices: false });
      this.props.history.push(generatePath("disablementlocation"));
    }
  };

  callCustomerService = () => {
    const { partnerDetails, commonBenefits } = this.props;
    datadogRum.addAction("ServiceTransition: Call for Assistance", {
      appId: partnerDetails.appId,
      memberId: commonBenefits.memberId,
    });
    callCustomerServicePhone(partnerDetails.partnerDetails?.phone, "Triage");
  };

  render() {
    let serviceName = localStorage.getItem(TRIAGE_TYPE);
    let serviceOrigin = localStorage.getItem(SERVICE_CHANGE_ORIGIN);
    let triageComponent;
    const { isTrunk } = this.state;

    switch (serviceName) {
      case "Tire Change":
        if(!this.isFerrari) {
          triageComponent = (
            <TireTriage
              updateSoftServiceDetails={this.updateSoftServiceDetails}
              partnerCode={this.props.displayCode}
            />
          );
        }
        break;

      case "Lockout":
        if(isABGPartner(this.props.displayCode) && serviceOrigin === TOW ) {
          triageComponent = (
            <TowToLockoutTriage
              updateSoftServiceDetails={this.updateSoftServiceDetails}
            />
          );
        } else {
          triageComponent = (
            <LockoutTriage
              towScreenDispatcher={this.towType}
              updateSoftServiceDetails={this.updateSoftServiceDetails}
            />
          );
        }
        break;

      case "Jump Start":
        if(!this.isFerrari) {
          triageComponent = (
            <JumpStartTriage
              updateSoftServiceDetails={this.updateSoftServiceDetails}
            />
          );
        }
        break;
      case FUEL_DELIVERY:
        triageComponent = (
          <FuelTriage
            updateSoftServiceDetails={this.updateSoftServiceDetails}
          />
        );
        break;
      case TOW:
        triageComponent = <TowTriage />;
        break;
      default:
        break;
    }
    const towService = this.props.commonBenefits.services?.find(
      (service) => service.type === TOW
    );
    const towCoveredMiles = towService?.towIncludedQty;
    const towCoverageAmount = towService?.coverageAmount;
    const maxClaimCount = this.props.commonBenefits?.maxClaimCount;
    const usageCount = this.props.commonBenefits?.usageCount;
    const benefits_used = maxClaimCount && usageCount ? maxClaimCount === usageCount : false;
    const status = this.props.commonBenefits?.status;
    const isMembershipActive = Boolean(
      towService && (!benefits_used && status?.toLowerCase() !== "contract cancelled" && status?.toLowerCase() !== "contract expired" && status?.toUpperCase() !== CONSTANTS.MUST_SHOW_NO_BENEFITS_PRICING_INFO)
    );


    return (
      <div role="main">
        {this.state.transitionToTowService ? (
          <TowTransition
            membership={isMembershipActive ? towService?.status !== CONSTANTS.SERVICE_STATUS_NOT_COVERED : false}
            type={serviceName === "Lockout" ? isTrunk : serviceName}
            towCost={this.props.serviceDetails.serviceDetails[0].displayCost}
            towToEnabled={this.props.towToEnabled}
            towUnsupported={this.props.partnerDetails.partnerDetails.experience?.excludedServiceTypes?.includes(
              "Tow"
            )}
            displayCode={this.props.displayCode}
            onClickTowTransition={this.handleClickTowTransition}
            handleContinueWithSoftService={this.updateSoftServiceDetails}
            onClickCallCustomerService={this.callCustomerService}
            milesBased={
              !!this.props.partnerDetails.partnerDetails.experience?.milesBased
            }
            dollarBased={
              !!this.props.partnerDetails.partnerDetails.experience?.dollarBased
            }
            towCoveredMiles={
              !!towCoveredMiles && towCoveredMiles !== "N/A"
                ? towCoveredMiles
                : ""
            }
            towCoverageAmount={!!towCoverageAmount ? towCoverageAmount : ""}
            isFerrari={this.isFerrari}
          />
        ) : this.state.transitionToTowNotNeeded ? (
          <TowNotNeeded navigateScheduleService={this.navigateScheduleService} />
        ) : (
          triageComponent
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    serviceDetails: state.serviceDetails,
    accessToken: state.accessToken,
    partnerDetails: state.partnerDetails,
    towToEnabled: state.partnerDetails.partnerDetails.experience?.towToEnabled,
    etaDetails: state.etaDetails,
    commonBenefits: state.commonBenefits,
    submitRequest: state.submitRequest,
    displayCode: state.partnerDetails.partnerDetails.displayCode,
    omniStreamlined: getOmniStreamlinedFlag(state)
  };
}

export default connect(mapStateToProps, {
  updateServiceInfo,
  requestPartnerDetails,
  updateServiceTypeOptions,
  updateCurrentLocation,
  updateTowReason,
  refreshReducersToInitial,
  clearServiceTypeOptions
})(Triage);
